import React from 'react';

import type { FieldMetaState } from '@/js/libs/final-form/index.ts';

import type { FormFieldProps } from './FormField.tsx';
import FormField from './FormField.tsx';

interface FinalFormFormFieldProps<TName extends string, TValue = string | undefined> extends FormFieldProps<TName> {
  meta: FieldMetaState<TValue>;
}

const FinalFormFormField = <TName extends string, TValue = string>({
  meta,
  children,
  ...restProps
}: FinalFormFormFieldProps<TName, TValue>) => {
  const { touched, error, submitError } = meta;

  return (
    <FormField {...restProps} error={error} submitError={submitError} touched={touched}>
      {children}
    </FormField>
  );
};

export default React.memo(FinalFormFormField) as typeof FinalFormFormField;
